import {smartWizard} from 'smartwizard'





// WEBPACK FOOTER //
// ./src/scripts/smartwizard.js